import { Time } from "@angular/common";
import { BaseDto } from "./base.dto";
import { MenuCategoryDto } from "./menuCategory.dto";

export class MenuCategoryHoursDto extends BaseDto {
    isAvailable: boolean;
    menuCategoryId: number;
    merchantId: number;
    weekday: number;
    startTime: Time;
    endTime: Time;
    menuCategory?: MenuCategoryDto;
  }